import { render, staticRenderFns } from "./TableItemLvl3.vue?vue&type=template&id=0db63a88"
import script from "./TableItemLvl3.vue?vue&type=script&lang=js"
export * from "./TableItemLvl3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports